import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyChoVayApi from "service/quanLyThuChiApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import ReactToPrint from "react-to-print";
import userApi from "service/userApi";
import { Cookies } from "react-cookie";
import danhSachThongTinVayApi from "service/ChoThongTin/danhSachThongTinVayApi";
import thongBaoThongTinVayApi from "service/ChoThongTin/thongBaoThongTinVayApi";

export const ModalThongBaoDangKyVayMoi = (props) => {
  const scrollRef = useRef();
  const [isRoleChoTinDung, setRoleChoTinDung] = useState(false);
  const urlChoTinDung = () => {
    props.onHide();
    window.open(window.urlChoTinDung + "cho-thong-tin/danh-sach-vay.aspx", '_blank');
  };
 
  return (
    <Modal
      {...props}
      size="modal-dialog modalNewTT"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail "
      backdrop="static"
    >
      <Modal.Body>
        <div style={{ textAlign: "center" }}>
          <div class="icon-box">
            <i class="mdi mdi-checkbox-marked-circle-outline"></i>
          </div>
          <h4>
          Khách hàng đăng ký mới 
          </h4>
          <p><span style={{ color: "#c0392b" }}> {props.iCountDataNew}</span> khách hàng vừa đăng ký chợ thông tin tín dụng mới.</p>
          <p>
            <a
              className="btn btn-new-main btn-closenew"
              data-dismiss="modal"
              href={() => false}
              target="_blank"
              onClick={urlChoTinDung}
            >
              Xem ngay !
            </a>
            &nbsp;&nbsp;&nbsp;
            <a
              className="btn btn-new-main btn-closenew"
              data-dismiss="modal"
              href={() => false}
              onClick={props.onHide}
            >
              Bỏ qua
            </a>
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};
